import React, { memo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import useModalState from 'hooks/useModalState';
import { GUEST_ROUTES } from 'routes/routes';
import styled from 'styled-components';
import useQueryParams from 'utils/useQueryParams';

import AuthForm from '../../../auth/tools/AuthForm';
import PublicGamesListTool from '../../../games/tools/PublicGamesListTool';
import NiceModal from '../../../modals/NiceModal';
import SubscriptionModal from '../../../modals/SubscriptionModal';
import UserTemplate from '../../../templates/UserTemplate/UserTemplate';
import CharactersList from '../../CharactersList';
import ChoosePlayButton from '../components/ChoosePlayButton';
import FaqSection from '../components/FaqSection';
import Header from '../components/Header';
import { USER_INDEX_TABS } from '../UserRootPage/constants';



const GuestRootPage = () => {
  const [isAuthModalOpen, openAuthModal, closeAuthModal] = useModalState();
  const { queryParams, updateQueryParams } = useQueryParams();
  const navigate = useNavigate();

  const [subscriptionModalState, setSubscriptionModalState] = useState({
    isOpen: false,
    renderedForReason: undefined
  });

  const activeTab = queryParams?.tab ?? USER_INDEX_TABS.SCENARIOS;

  const isScenariosActiveTab = activeTab === USER_INDEX_TABS.SCENARIOS;
  const isCharactersActiveTab = activeTab === USER_INDEX_TABS.CHARACTERS;

  const setActiveTab = tab => updateQueryParams({ tab });


  const handleScenarioItemClick = (item) => {
    if (!item?.isLocked) {
      navigate(GUEST_ROUTES.ROLEPLAY(item.alias));
    } else {
      openAuthModal();
    }
  };

  const handleCloseSubscriptionModal = () => {
    setSubscriptionModalState({
      isOpen: false,
      renderedForReason: undefined
    });
  };

  const handleCreateScenario = (tags = []) => {
    const searchParams = new URLSearchParams();
    if (tags.length > 0) {
      searchParams.set('tags', JSON.stringify(tags));
    }
    navigate(`${GUEST_ROUTES.SCENARIOS_GENERATOR()}${searchParams.toString() ? '?' + searchParams.toString() : ''}`);
  };

  return (
    <UserTemplate currentName={'guest_index'} hasHero={true} stickyHeader={true} promotionBanner>
      <Header
        activeTab={activeTab}
        setActiveTab={setActiveTab}
      />
      {isScenariosActiveTab && (
        <ScenariosPlaceholder>
          <PublicGamesListTool
            onCreateScenario={handleCreateScenario}
            onItemClick={handleScenarioItemClick}
            onAuthClick={openAuthModal}
          />
        </ScenariosPlaceholder>
      )}
      {isCharactersActiveTab && (
        <CharactersList />
      )}
      <FaqSection onClickSubscriptionText={openAuthModal} onOpenCreateScenarioModal={handleCreateScenario} />
      <ChoosePlayButton />
      {subscriptionModalState.isOpen && (
        <SubscriptionModal
          analyticsData={{
            rendered_for_reason: subscriptionModalState.renderedForReason
          }}
          isOpen
          onClose={handleCloseSubscriptionModal}
        />
      )}

      {isAuthModalOpen && (
        <NiceModal onClose={closeAuthModal}>
          <ModalInnerPlaceholder>
            <AuthForm onClose={closeAuthModal} />
          </ModalInnerPlaceholder>
        </NiceModal>
      )}
    </UserTemplate>
  );
};

export default memo(GuestRootPage);

const ModalInnerPlaceholder = styled.div`
  width: 380px;
  padding: 30px;
  box-sizing: border-box;
  @media (max-width: 400px) {
    width: 100%;
  }
`;

const ScenariosPlaceholder = styled.div`
  @media (max-width: 1280px) {
    margin-left: 10px;
    margin-right: 10px;
  }
`;
